<footer class="container-fluid bg-danger fixed-bottom">
  <div class="row p-2">
    <div class="col-4 text-center text-white">Github App</div>
    <div class="col-8 text-center text-white">Copyright by Iromashko</div>
  </div>
</footer>
